import { render, staticRenderFns } from "./SubGroupsMenu.vue?vue&type=template&id=c12a57e4&scoped=true"
import script from "./SubGroupsMenu.vue?vue&type=script&lang=js"
export * from "./SubGroupsMenu.vue?vue&type=script&lang=js"
import style0 from "./SubGroupsMenu.vue?vue&type=style&index=0&id=c12a57e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12a57e4",
  null
  
)

export default component.exports